﻿import DM from 'DM';

function genereteUrl({ id, url }) {
    return `//creativecdn.com/tags?type=script&id=pr_S6iN5ZJTAISxwyY6O0HL_${url}`;
}

export default class RTBTracker {
    constructor() {
        this.name = 'rtb';
    }

    dispatch(event, payload) {
        if (typeof this[event] === 'function') {
            const url = genereteUrl(this[event](payload));

            DM.LoadScript.register(url, {
                defer: true
            });
        }
    }

    homeView() {
        return {
            url: 'home'
        };
    }

    productsView({ products }) {
        const productList = products.slice(0, 10).map(product => (
            product.productId
        )).join(',');

        return {
            url: `listing_${productList}`
        };
    }

    productLightboxView({ productId }) {
        return {
            url: `offer_${productId}`
        };
    }

    productDetailsView({ productId }) {
        return {
            url: `basketadd_${productId}`
        };
    }
}
